module.exports = __webpack_public_path__ + "static/media/show_columns.5c28266f.svg";